
import { _authorizedRequest, _authorizedDownloadRequest, _request, _authorizedRequestWithHeader } from '../http'

function encodeQueryValue(value) {
    return encodeURIComponent(value == null ? "" : value)
}

export async function getModel(platform, model) {
    return _authorizedRequest("GET", `/Mapping/${model}/${platform}`, null)
}

export async function getConfig(platform, model) {
    return _authorizedRequest("GET", `/DefaultConfig/${platform}/${model}`, null)
}

export async function saveConfig(data) {
    return _authorizedRequest("PUT", `/DefaultConfig`, data)
}


export async function settingQuickbook(data) {
    return _authorizedRequest("POST", `/QuickBooks/config`, data)
}

export async function quickBooksItems(search) {
    return _authorizedRequest("GET", `/QuickBooks/product?search=${encodeQueryValue(search)}`, null)
}

export async function quickBooksCustomers(search) {
    return _authorizedRequest("GET", `/QuickBooks/customer?search=${encodeQueryValue(search)}`, null)
}
export async function quickBooksOrders(search) {
    return _authorizedRequest("GET", `/QuickBooks/order?search=${encodeQueryValue(search)}`, null)
}

export async function quickBooksCompanyInfo() {
    return _authorizedRequest("GET", `/QuickBooks/company`, null)
}

export async function settingFora(data) {
    return _authorizedRequest("POST", `/Fora/config`, data)
}

export async function getSettingFora() {
    return _authorizedRequest("GET", `/Fora`, null)
}

export async function getForaOrderDetail(search) {
    return _authorizedRequest("GET", `/Fora/orderdetail?search=${encodeQueryValue(search)}`, null)
}

export async function getHealth() {
    return _authorizedRequest("GET", `/Fora/health`, null)
}


export async function foraOrders() {
    return _authorizedRequest("GET", `/Fora/order`, null)
}

export async function foraOrdersOrQuotes(orderType, date) {
    return _authorizedRequest("GET", `/Fora/orders?orderType=${encodeQueryValue(orderType)}&date=${encodeQueryValue(date)}`, null)
}



export async function getCustomConfig(platform, model) {
    return _authorizedRequest("GET", `/CustomConfig/${platform}/${model}`, null)
}

export async function saveCustomConfig(data) {
    return _authorizedRequest("PUT", `/CustomConfig`, data)
}

export async function runJobCustomer(data) {
    return _authorizedRequest("POST", `/RunJob/customer`, data)
}

export async function runJob(entity, cron) {
    return _authorizedRequest("POST", `/RunJob/${entity}/${cron}`, null)
}

export async function deleteJob(jobId) {
    return _authorizedRequest("DELETE", `/RunJob/${jobId}`, null)
}


export async function runJobState() {
    return _authorizedRequest("GET", `/RunJob/state`, null)
}

export async function logs(data) {
    return _authorizedRequest("GET", `/Result?` + jsonToQueryString(data), null)
}

function jsonToQueryString(json) {
    return Object.keys(json)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`)
        .join('&');
}

export async function sync(data) {
    return _authorizedRequest("POST", `/RunJob/quickbooks_online`, data)
}

export async function syncQBDCustomer(header, customers) {
    return _authorizedRequestWithHeader("POST", `/RunJob/quickbooks_desktop/customers`, customers, header)
}

export async function syncQBDProduct(header, products) {
    return _authorizedRequestWithHeader("POST", `/RunJob/quickbooks_desktop/products`, products, header)
}

export async function disconnectQuickBooks() {
    return _authorizedRequestWithHeader("DELETE", `/QuickBooks/authorize`, null)
}

export async function upload(data, type) {
    return _authorizedRequest("POST", `/csv/upload/${type}`, data)
}

export async function csv() {
    return _authorizedRequest("GET", `/csv/files`, null)
}

export async function searchCsv(search, type) {
    return _authorizedRequest("GET", `/csv/sample?type=${encodeQueryValue(type)}&search=${encodeQueryValue(search)}`, null)
}

export async function searchCsvFirstRow(type) {
    return _authorizedRequest("GET", `/csv/sample/fistrow?type=${type}`, null)
}

export async function syncCsv(data) {
    return _authorizedRequest("POST", `/csv/sync`, data)
}

export async function downloadCsv(data, filename) {
    //download exported result
    return _authorizedDownloadRequest("POST", `/csv/download`, data, filename.replace(".csv", ""))
}

export async function getMappingCSV(target, filename) {
    //download mapping file
    return _authorizedDownloadRequest("GET", `/Mapping/download/${target}`, null, filename.replace(".csv", ""))
}

export async function deleteLog(id) {
    return _authorizedRequest("DELETE", `/Result/${id}`, null)
}
